<app-loader></app-loader>
<div *ngIf="userCommonService?.isMetadataLoaded" class="device-height">
  <div class="main-panel container">
    <app-sidebar *ngIf="loadUI()" class="sidebar scroll-bar-css left-panel"></app-sidebar>
    <div class="right-panel bg-white overflowHide flex flex-column" id="rightPanel">
      <app-header *ngIf="loadUI()" class="navbar"></app-header>
      <div class="right-panel-content scroll-bar-css" id="rightPanelContent">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-message></app-message>
<app-image-preview-dialog></app-image-preview-dialog>